import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { CustomState } from "../CustomState";
import { InvestigacionesAcciones } from "../investigaciones";
import { GlobalAcciones } from "./global.acciones";

export interface IGlobalState {
    esTelefono: boolean;
    esTablet: boolean;
}

@State<IGlobalState>({
    name: "global",
    defaults: {
        esTelefono: false,
        esTablet: false
    }
})
@Injectable()
export class GlobalState extends CustomState<IGlobalState> {
    @Action(GlobalAcciones.EstablecerEsTelefono)
    public establecerEsTelefono(ctx: StateContext<IGlobalState>, action: GlobalAcciones.EstablecerEsTelefono) {
        const nuevoState = this.obtenerNuevoState(ctx);

        nuevoState.esTelefono = action.esTelefono;

        ctx.setState(nuevoState);
    }

    @Action(GlobalAcciones.EstablecerEsTablet)
    public establecerEsTablet(ctx: StateContext<IGlobalState>, action: GlobalAcciones.EstablecerEsTablet) {
        const nuevoState = this.obtenerNuevoState(ctx);

        nuevoState.esTablet = action.esTablet;

        ctx.setState(nuevoState);
    }

    @Action(GlobalAcciones.Salir)
    public salir(ctx: StateContext<IGlobalState>) {
        ctx.dispatch(new InvestigacionesAcciones.Salir());
    }
}
